<div id="task" class="page-layout carded left-sidenav" style="background-color: #777770 !important">
  <!-- TOP BACKGROUND -->
  <div fxFill style="background-color: #fafafa; z-index: 1; position: absolute"></div>
  <div class="top-bg mat-accent-bg" style="height: 184px"></div>
  <!-- / TOP BACKGROUND -->

  <mat-sidenav-container style="background-color: transparent !important">
    <!-- SIDENAV -->
    <mat-sidenav class="sidenav" align="start" opened="true" mode="side" fuseMatSidenavHelper="carded-left-sidenav"
      mat-is-locked-open="gt-md" style="border-right: none">
      <app-report-options id="reportingOptions"></app-report-options>
    </mat-sidenav>
    <!-- / SIDENAV -->

    <!-- CENTER -->
    <mat-sidenav-content>
      <div class="center" style="width: 100px">
        <!-- CONTENT HEADER -->
        <div class="header" fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex fxLayout="row" fxLayoutAlign="start center">
            <button mat-button class="mat-icon-button sidenav-toggle" fuseMatSidenavToggler="carded-left-sidenav"
              fxHide.gt-md aria-label="Toggle Filters">
              <mat-icon class="white-fg pr-16">filter_alt</mat-icon>
            </button>
            <div class="logo-text h1 white-fg">{{ report?.name }}</div>
          </div>

          <div *ngIf="!noData" class="toolbar white-fg" fxLayout="row" fxLayoutAlign="end center">
            <div *ngIf="showChart" style="display: flex">
              <div class="px-16 py-4 clickable" fxLayout="row" fxLayoutAlign="start center"
                [matMenuTriggerFor]="chartTypeMenu" #chartTypeMenuTrigger="matMenuTrigger" matTooltip="Chart Type"
                (mouseenter)="chartTypeMenuTrigger.openMenu()" (click)="chartTypeMenuTrigger.openMenu()"
                aria-label="Chart Type">
                <mat-icon class="mr-4">insights</mat-icon>
                <span>Chart Type</span>
              </div>
              <mat-menu #chartTypeMenu="matMenu" [overlapTrigger]="false">
                <div (mouseleave)="chartTypeMenuTrigger.closeMenu()">
                  <button mat-menu-item (click)="setChartType('Bar')">
                    <mat-icon class="mr-4">{{
                      chartType === "Bar" ? "done" : undefined
                      }}</mat-icon>
                    Bar
                  </button>
                  <button mat-menu-item (click)="setChartType('Doughnut')">
                    <mat-icon class="mr-4">{{
                      doughnut ? "done" : undefined
                      }}</mat-icon>Doughnut
                  </button>
                  <button mat-menu-item (click)="setChartType('Pie')">
                    <mat-icon class="mr-4">{{
                      chartType === "Pie" && !doughnut ? "done" : undefined
                      }}</mat-icon>Pie
                  </button>
                </div>
              </mat-menu>

              <mat-divider class="style-fix" [vertical]="true"></mat-divider>
            </div>

            <div *ngIf="showData" style="display: flex">
              <button *ngIf="!showFilter" mat-button id="showFilter" #showFilterButton (click)="toggleFilterRow()"
                matTooltip="Show Filter">
                <mat-icon class="mr-4">filter_alt</mat-icon>
                <span class="white-fg">Filter</span>
              </button>

              <button *ngIf="showFilter" color="secondary" mat-button id="showFilter" #hideFilterButton
                (click)="toggleFilterRow()" matTooltip="Hide Filter">
                <mat-icon class="mr-4">clear</mat-icon>
                <span class="white-fg">Filter</span>
              </button>

              <button mat-button id="reset" #resetButton (click)="reset()" aria-label="Reset" matTooltip="Reset">
                <mat-icon class="mr-4">restart_alt</mat-icon>
                <span class="white-fg">Reset</span>
              </button>

              <button mat-button id="export" #exportButton (click)="export()" matTooltip="Export">
                <mat-icon class="mr-4">file_download</mat-icon>
                <span class="white-fg">Export</span>
              </button>

              <mat-divider class="style-fix" [vertical]="true"></mat-divider>
            </div>

            <div *ngIf="showViewMenu" class="px-16 py-4 clickable" fxLayout="row" fxLayoutAlign="start center"
              [matMenuTriggerFor]="viewMenu" #viewMenuTrigger="matMenuTrigger" matTooltip="Change View"
              (mouseenter)="viewMenuTrigger.openMenu()" (click)="viewMenuTrigger.openMenu()" aria-label="View">
              <mat-icon class="mr-4">leaderboard</mat-icon>
              <span>View</span>
            </div>
            <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
              <div (mouseleave)="viewMenuTrigger.closeMenu()">
                <button mat-menu-item (click)="viewReport('chartdata')">
                  <mat-icon class="mr-4">{{
                    showChart && showData ? "done" : undefined
                    }}</mat-icon>
                  Chart & Data
                </button>
                <button mat-menu-item (click)="viewReport('chart')">
                  <mat-icon class="mr-4">{{
                    showChart && !showData ? "done" : undefined
                    }} </mat-icon>Chart
                </button>
                <button mat-menu-item (click)="viewReport('data')">
                  <mat-icon class="mr-4">{{
                    showData && !showChart ? "done" : undefined
                    }} </mat-icon>Data
                </button>
              </div>
            </mat-menu>

            <button mat-button id="print" #print (click)="printReport()" aria-label="Print" matTooltip="Print">
              <mat-icon class="mr-4">print</mat-icon>
              <span class="white-fg">Print</span>
            </button>

            <button *ngIf="!userReadOnly" mat-button id="save" #btnSave (click)="save()" matTooltip="Save Report">
              <mat-icon class="mr-4">save</mat-icon>
              <span class="white-fg">Save</span>
            </button>

            <button *ngIf="!userReadOnly" mat-button id="saveAs" #btnSaveAs (click)="saveAs()"
              matTooltip="Save Report As">
              <mat-icon class="mr-4">save_as</mat-icon>
              <span class="white-fg">Save As</span>
            </button>
          </div>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <dx-load-panel
          #loadPanel
          shadingColor="rgba(0,0,0,0.4)"
          [position]="{ of: '#content' }"
          [(visible)]="loadingVisible"
          [showIndicator]="true"
          [showPane]="true"
          [shading]="true"
          [hideOnOutsideClick]="false"  
          message="Preparing Report..."
        >
        </dx-load-panel>

        <div #content class="content-card mat-white-bg" style="position: relative; overflow-y: auto">
          <!-- CONTENT -->
          <div *ngIf="noData" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <span class="no-data hint-text pt-32 h1">No data to display</span>
          </div>
          <div *ngIf="!noData" fxLayout="column">
            <div *ngIf="showChart && chartData && chartData.length > 0" class="p-48">

              <dx-pie-chart *ngIf="chartType === 'Pie'" id="pie" [title]="title" [type]="pieType" palette="bright" 
                [dataSource]="chartData" [resolveLabelOverlapping] ="shift"
                (onPointHoverChanged)="onPointHoverChanged($event)" (onPointClick)="onPointClick($event)"
                  >
                    <dxo-legend [visible]="true" [customizeItems]="sortLegendItems" >                      
                      <dxo-font size="14"></dxo-font>
                    </dxo-legend>
                    <dxi-series argumentField="name" valueField="value">
                    </dxi-series>
                    <dxo-tooltip [enabled]="false" [customizeTooltip]="pieChartTooltip" zIndex="1000" color="#616161"  >
                      <dxo-border color="#616161"></dxo-border>
                      <dxo-font size="14" color="white"></dxo-font>
                    </dxo-tooltip>
              </dx-pie-chart>

              <dx-chart id="chart" *ngIf="chartType === 'Bar'" [dataSource]="chartData" [title]="title" [palette]="bright"
              (onPointHoverChanged)="onPointHoverChanged($event)" (onPointClick)="onPointClick($event)">

                <dxo-legend [visible]="false">
                  <dxo-font size="14"></dxo-font>
                </dxo-legend>

                <dxo-argument-axis>      
                  <dxo-label  [displayMode]="'rotate'"  [rotationAngle]="45" [overlappingBehavior]="'none'" >
                    <dxo-font size="14"></dxo-font>
                  </dxo-label>
                </dxo-argument-axis>

                <dxo-common-series-settings argumentField="name" type="bar" valueField="value" [ignoreEmptyPoints]="true" [barPadding]="10">                                
                </dxo-common-series-settings>

                <dxo-series-template nameField="name">                
                </dxo-series-template>             

                <dxo-tooltip [enabled]="false" [customizeTooltip]="barChartTooltip" zIndex="1000" color="#616161">
                  <dxo-font size="14" color="white"></dxo-font>
                  <dxo-border color="#616161"></dxo-border>
                </dxo-tooltip>
              </dx-chart>
            </div>
            <br/>
            <mat-divider *ngIf="showData && showChart" class="pb-4"></mat-divider>
            <br/>
            <div *ngIf="showData" class="h-100-p w-100-p p-16">
              <data-grid style="max-height: 100%" #datagrid id="lstData" [rows]="listData" [columns]="columns"
                [showButtons]="false" [showPager]="true" [keyProperty]="Id" [allowCustomisation]="true"
                (onFilterVisibilityChanged)="filterVisibilityChanged($event)">
              </data-grid>
            </div>
          </div>
          <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->
      </div>
    </mat-sidenav-content>
    <!-- / CENTER -->
  </mat-sidenav-container>
</div>
